import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class ExecutiveSummaryStore {

  @observable total_data = [];
  @observable total_claims = [];
  @observable Pmpm_yearly = [];
  @observable theraputic_class_breakdown = [];
  @observable drug_breakdown = [];
  @observable drug_breakdown_dynamic = [];
  @observable drug_breakdown_specialty = [];
  @observable drug_breakdown_generic = [];
  @observable drug_breakdown_brand = [];
  @observable drug_breakdown_pharmacy = [];
  @observable drug_breakdown_provider = [];
  @observable user_all_groups = [];
  @observable p_count = 0;
  @observable utilization_day_start_year = 0;
  @observable utilization_day_end_year = 0;
  @observable rebates_start_year = 0;
  @observable rebates_end_year = 0;
  @observable specialty_utilizers_start_year = 0;
  @observable specialty_utilizers_end_year = 0;
  @observable generic_total_drugs_start_year = 0;
  @observable generic_total_drugs_end_year = 0;
  @observable total_employees_start_year = 0;
  @observable total_employees_end_year = 0;
  @observable total_participants_start_year = 0;
  @observable total_participants_end_year = 0;
  @observable plan_pay_sum = 0;
  @observable Participants_yearly = {};
  @observable claims_summary = {};
  @observable plan_pay_summary = {};
  @observable co_pay_summary = {};
  @observable specialty_metrics = {};
  @observable brand_metrics = {};
  @observable generic_metrics = {};
  @observable branded = {};
  @observable generic = {};
  @observable specialty = {};
  @observable action = false;
  @observable errors = {};
  @observable url = "/api/v1/executiveSummaryActions";



  @action setErrors = () => {
    this.errors = {};
  };
  @action setAction = action => {
    this.action = action;
  };

  @action getTotalPlanSpend = async data => {
    this.total_data = [];
    try {
      let response = await post(
        `${this.url}/getTotalPlanSpend`,
        data
      );
      this.total_data = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  @action getTotalClaimsByGroup = async data => {
    this.total_claims = [];
    try {
      let response = await post(
        `${this.url}/getTotalClaims`,
        data
      );
      this.total_claims = response.data[0].total_claims_of_group;
    } catch (err) {
      console.log(err);
    }
  };
  @action getBrandedOfYear = async data => {
    this.branded = {};
    try {
      let response = await post(
        `${this.url}/getBrandedOfYear`,
        data
      );
      this.branded = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  @action getGenericOfYear = async data => {
    this.generic = {};
    try {
      let response = await post(
        `${this.url}/getGenericOfYear`,
        data
      );
      this.generic = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  @action getSpecialtyOfYear = async data => {
    this.specialty = {};
    try {
      let response = await post(
        `${this.url}/getSpecialtyOfYear`,
        data
      );
      this.specialty = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getPMPMYearly = async data => {
    this.Pmpm_yearly = [];
    try {
      let response = await post(
        `${this.url}/getPMPMYearly`,
        data
      );
      this.Pmpm_yearly = response.data.data[0];
      this.p_count = response.data
    } catch (err) {
      console.log(err);
    }
  };


  @action getTotalParticipantsYearly = async data => {
    this.Participants_yearly = {};
    try {
      let response = await post(
        `${this.url}/getTotalParticipantsYearly`,
        data
      );
      this.Participants_yearly = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  @action getTheraputicClassBreakDown = async data => {
    this.theraputic_class_breakdown = [];
    try {
      let response = await post(
        `${this.url}/getTheraputicClassBreakDown`,
        data
      );
      this.theraputic_class_breakdown = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getDrugsBreakDown = async data => {
    this.drug_breakdown = [];
    try {
      let response = await post(
        `${this.url}/getDrugsBreakDown`,
        data
      );
      this.drug_breakdown = response.data.data;

      let count = this.drug_breakdown.length;
      let loop_index = 0;
      if (count <= 10) {
        this.drug_breakdown_dynamic.push({ index0: this.drug_breakdown })
      }
      else {
        this.drug_breakdown_dynamic.push({ index0: this.drug_breakdown.slice(0, 10) })
        loop_index = parseInt((count - 10) / 14);
        let start_index = 10;
        let end_index = 10;
        for (var i = 0; i <= loop_index; i++) {
          this.drug_breakdown_dynamic.push({ [`index${i + 1}`]: this.drug_breakdown.slice(start_index, end_index) })
          start_index += 10;
          end_index += 10;
        }
      }

    } catch (err) {
      console.log(err);
    }
  };
  @action getDrugsBreakDownSpecialty = async data => {
    this.drug_breakdown_specialty = [];
    try {
      let response = await post(
        `${this.url}/getDrugsBreakDownSpecialty`,
        data
      );
      this.drug_breakdown_specialty = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getDrugsBreakDownGeneric = async data => {
    this.drug_breakdown_generic = [];
    try {
      let response = await post(
        `${this.url}/getDrugsBreakDownGeneric`,
        data
      );
      this.drug_breakdown_generic = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getDrugsBreakDownBrand = async data => {
    this.drug_breakdown_brand = [];
    try {
      let response = await post(
        `${this.url}/getDrugsBreakDownBrand`,
        data
      );
      this.drug_breakdown_brand = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPharmacyBreakDown = async data => {
    this.drug_breakdown_pharmacy = [];
    try {
      let response = await post(
        `${this.url}/getPharmacyBreakDown`,
        data
      );
      this.drug_breakdown_pharmacy = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getProviderBreakDown = async data => {
    this.drug_breakdown_provider = [];
    try {
      let response = await post(
        `${this.url}/getProviderBreakDown`,
        data
      );
      this.drug_breakdown_provider = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPlanPaySum = async data => {
    this.plan_pay_sum = 0;
    try {
      let response = await post(
        `${this.url}/getPlanPaySum`,
        data
      );
      this.plan_pay_sum = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getClaimsCostSummary = async data => {
    this.claims_summary = {};
    try {
      let response = await post(
        `${this.url}/getClaimsCostSummary`,
        data
      );
      this.claims_summary = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getParticipantsCostSummary = async data => {
    this.co_pay_summary = {};
    try {
      let response = await post(
        `${this.url}/getParticipantsCostSummary`,
        data
      );
      this.co_pay_summary = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPlanCostSummary = async data => {
    this.plan_pay_summary = {};
    try {
      let response = await post(
        `${this.url}/getPlanCostSummary`,
        data
      );
      this.plan_pay_summary = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getSpecialtyKeyMetrics = async data => {
    this.specialty_metrics = {};
    try {
      let response = await post(
        `${this.url}/getSpecialtyKeyMetrics`,
        data
      );
      this.specialty_metrics = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getBrandKeyMetrics = async data => {
    this.brand_metrics = {};
    try {
      let response = await post(
        `${this.url}/getBrandKeyMetrics`,
        data
      );
      this.brand_metrics = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getGenericKeyMetrics = async data => {
    this.generic_metrics = {};
    try {
      let response = await post(
        `${this.url}/getGenericKeyMetrics`,
        data
      );
      this.generic_metrics = response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getAllUserGroups = async data => {
    this.user_all_groups = [];
    try {
      let response = await post(
        `${this.url}/getAllUserGroups`,
        data
      );

      this.user_all_groups = response.data;
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getUtilizationDay = async data => {
    this.utilization_day_start_year = 0;
    this.utilization_day_end_year = 0;
    try {
      let response = await post(
        `${this.url}/getUtilizationDay`,
        data
      );

      this.utilization_day_start_year = response.data?.data?.days_utilization_start_year;
      this.utilization_day_end_year = response.data?.data?.days_utilization_end_year;
    } catch (err) {
      console.log(err);
    }
  };
  @action getRebates = async data => {
    this.rebates_start_year = 0;
    this.rebates_end_year = 0;
    try {
      let response = await post(
        `${this.url}/getRebates`,
        data
      );

      this.rebates_start_year = response.data?.data?.start_year_total_rebates;
      this.rebates_end_year = response.data?.data?.end_year_total_rebates;
    } catch (err) {
      console.log(err);
    }
  };
  @action getGenericDispensing = async data => {
    this.specialty_utilizers_start_year = 0;
    this.specialty_utilizers_end_year = 0;
    this.specialty_utilizers_start_year = 0;
    this.specialty_utilizers_end_year = 0;
    try {
      let response = await post(
        `${this.url}/getGenericDispensing`,
        data
      );

      this.specialty_utilizers_start_year = response.data?.data?.specialty_utilizers_start_year;
      this.specialty_utilizers_end_year = response.data?.data?.specialty_utilizers_end_year;
      this.total_drugs_start_year = response.data?.data?.total_drugs_start_year;
      this.total_drugs_end_year = response.data?.data?.total_drugs_end_year;
    } catch (err) {
      console.log(err);
    }
  };
  @action getAverageParticipantShip = async data => {
    this.total_employees_start_year = 0;
    this.total_employees_end_year = 0;
    this.total_participants_start_year = 0;
    this.total_participants_end_year = 0;
    try {
      let response = await post(
        `${this.url}/getAverageParticipantShip`,
        data
      );

      this.total_employees_start_year = response.data?.data?.total_employees_start_year;
      this.total_employees_end_year = response.data?.data?.total_employees_end_year;
      this.total_participants_start_year = response.data?.data?.total_participants_start_year;
      this.total_participants_end_year = response.data?.data?.total_participants_end_year;
    } catch (err) {
      console.log(err);
    }
  };

}

export default ExecutiveSummaryStore;
